import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoryItineraryComponent } from './inventory-itinerary.component';
import { ItineraryListComponent } from './list/itinerary-list.component';
import { ItineraryDetailsComponent } from './add/itinerary-details/itinerary-details.component';
import { ItineraryFormComponent } from './add/itinerary-form.component';
import { OverviewItineraryComponent } from './overview-itinerary/overview-itinerary.component';

const routes: Routes = [
  { path: '', component:InventoryItineraryComponent, 
    children: [
      { path: '' , redirectTo: 'list', pathMatch: 'full'},
      {path: 'list', component: ItineraryListComponent},
      {path: 'itinerary', component: ItineraryFormComponent},
      {path: 'overview', component: OverviewItineraryComponent}
    ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoryItineraryRoutingModule { }
